module.exports = ".well .add-button{width:100%;vertical-align:middle;margin-top:20px}.x_title{border:0}\n"